module.exports = __webpack_public_path__ + "img/blue1.46bb0d2b.svg";